<template>
	<inertia-head title="Sales Report" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 v-if="$page.props.user.is_super_sponsor==1" class="badge bg-warning text-white fs-lg">SUPER AFFILIATE</h1>
					<h1 class="fw-bold text-white mb-2">Sales Report</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm"></h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-header border-bottom">
				<h3 class="block-title">New System</h3>
			</div>
			<div class="block-content block-content-full">
				<!--START horizontal filters -->
				<div class="row">
					<div class="col-md-8">
						<div class="row mb-4">
							<label class="col-sm-1 col-form-label fs-sm">Show</label>
							<div class="col-sm-2">
								<select
									v-model="per_page"
									class="form-control form-control-sm"
								>
									<option
										v-for="per_page in [5, 10, 20, 50, 100]"
										:key="per_page"
										:value="per_page"
									>
										{{ per_page }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-md-4">
						<div class="row mb-4">
							<label class="col-sm-3 col-form-label fs-sm">Search</label>
							<div class="col-sm-9">
								<input
									v-model="query"
									type="search"
									class="form-control fs-sm form-control-sm"
									placeholder="Search here..."
								/>
							</div>
						</div>
					</div>
				</div>
				<!--END horizontal filters -->
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-vcenter">
						<thead>
							<tr>
								<th>#</th>
								<th>Trans#/Date</th>
								<th>Email</th>
								<th>Course</th>
								<th>Comms</th>
								<th>Source</th>
							</tr>
						</thead>
						<tbody v-if="newSystem.data.length>0" class="fs-sm">
							<tr v-for="(newData, index) in newSystem.data" :key="`new-${index}`">
								<td>{{ index + 1 }}</td>
								<td>
									<p class="mb-0">{{ newData.transdate }}</p>
									<small class="text-muted">{{ newData.transtime }}</small>
								</td>
								<td>
									<p class="mb-0">{{ newData.f_owner }}</p>
									<small class="text-info fs-xs">{{ newData.g_owner }}</small>
								</td>
								<td>{{ newData.course }}</td>
								<td>{{ newData.amount }}</td>
								<td>{{ newData.source }}</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="6">
									<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="newSystem.data.length > 0" :collections="newSystem"/>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-header border-bottom">
				<h3 class="block-title">Old System</h3>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-vcenter">
						<thead class="text-center">
							<tr>
								<th>#</th>
								<th>Trans#/Date</th>
								<th>Email</th>
								<th>Comms</th>
							</tr>
						</thead>
						<tbody v-if="oldSystem.data.length > 0">
							<tr v-for="(oldData, index) in oldSystem.data" :key="`old-${index}`">
								<td>{{ index + 1 }}</td>
								<td>{{ oldData.transdate }}</td>
								<td>{{ oldData.g_owner }}</td>
								<td>{{ oldData.amount }}</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="4">
									<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="oldSystem.data.length > 0" :collections="oldSystem"/>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../../Layouts/AuthLayout';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	props: {
		newSystem 	: Object,
		oldSystem 	: Object,
		filters 	: Object
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const query 			= ref(props.filters.query);

		const per_page 			= ref(props.filters.per_page ?? 5);

		const oldsys_query 		= ref(props.filters.oldsys_query)

		const oldsy_per_page 	= ref(props.filters.oldsy_per_page ?? 5);

		watch(
			[query,oldsys_query],
			function ([value,oldsys_value],[old_value,old_oldsys_value]) {
				var param ={
								per_page : per_page.value
							};
				var param1 ={
								oldsy_per_page : oldsy_per_page.value
							}

				if(value!='')
				{
					param.query = value;
				}

				if(oldsys_value!='')
				{
					param1.oldsys_query = oldsys_value;
				}

				if(value!=old_value)
				{
					Inertia.get(
						'/member/affiliate-program/sales-report', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['newSystem', 'filters']
						}
					)

				}

				if(oldsys_value!=old_oldsys_value)
				{
					Inertia.get(
						'/member/affiliate-program/sales-report', param1,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['oldSystem', 'filters']
						}
					)
				}
			}
		)

		watch([per_page,oldsy_per_page], ([value,oldsys_value],[old_value,old_oldsys_value]) => {
			var param 	= { per_page:value };
			var param1 	= { oldsy_per_page:oldsys_value };

			if(query.value!='')
			{
				param.query = query.value;
			}

			if(oldsys_query.value!='')
			{
				param1.oldsys_query = oldsys_query.value;
			}

			if(value!=old_value)
			{
				Inertia.get(
					'/member/affiliate-program/sales-report', param,
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['newSystem', 'filters']
					}
				)
			}

			if(oldsys_value!=old_oldsys_value)
			{
				Inertia.get(
					'/member/affiliate-program/sales-report', param1,
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['oldSystem', 'filters']
					}
				)
			}
			
		})

		return {
			query,
			per_page,
			oldsys_query,
			oldsy_per_page
		}
	},
}
</script>
